var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.path === '/all_orders')?_c('order-list'):_vm._e(),(_vm.$route.path === '/open_orders')?_c('open-order-list'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }